<template>
  <div class="modules-content" style="margin-top:0px;">
    <confirmation-modal
      :loading="deleteLoading"
      :text="'Deseja realmente cancelar a inscrição?'"
      @confirm="removeSubscription"
      @cancel="deleteSubscription=null"
      v-if="deleteSubscription!=null"
    />
    <new-subscription v-if="showNew" @saved="getSubscriptions" @close="showNew=false" :userId="userId" />
    <div class="module-item" data-id="1" data-module-lessons="23">
      <div class="title-content custom-grid">
        <h3 class="module-title" style="font-size: 14px;">
          Inscrições
          <i class="icon icon-alert-circle-i"></i>
          <div class="module-description-tooltip">Inscrições</div>
        </h3>

        <div></div>
        <span class="module-progress loading-placeholder" style="display: block;"></span>

        <span class="module-progress loading-placeholder" style="display: block;">
          <lms-button style="margin-right:5px;" @click="newSubscription" :loading="loadingData">Novo</lms-button>
        </span>
      </div>

      <li
        class="lesson-subtitle"
        style=" grid-template-columns:1.5fr 22rem  10rem 1.25fr 1.25fr .75fr;"
      >
        <span class="lesson-title">Curso</span>
        <span class="lesson-title">Pagamento</span>
        <span class="lesson-status">Status</span>
        <span class="lesson-title">Início</span>
        <span class="lesson-title">Final</span>

        <!-- <span class="lesson-option"></span> -->
      </li>

      <ul class="lessons-list">
        <li
          style="grid-template-columns:1.5fr 22rem  10rem 1.25fr 1.25fr .75fr;"
          v-for="(sub,index) in subscriptions"
          :key="index"
          class="lesson"
          data-id="64"
          data-videos="1"
        >
          <span class="lesson-title">{{sub.productName}}</span>
          <span class="lesson-title">{{sub.paymentDate}}</span>

          <span v-if="sub.status == 3" class="lesson-status" style="display: flex;">
            <span class="lesson-status finished loading-placeholder">
              <span class="icon icon-c-check"></span> Pago
            </span>
          </span>
          <span v-else class="lesson-status" style="display: flex;">
            <span class="lesson-status in-progress loading-placeholder">
              <i class="material-icons">error_outline</i>Não pago
            </span>
          </span>

          <span class="lesson-title">{{sub.startTimestamp | formatDate}}</span>

          <span class="lesson-title">{{sub.endTimestamp | formatDate}}</span>

          <span class="lesson-option">
            <lms-button
              style="margin-right:5px;"
              @click="deleteSubscription={paymentId:sub.paymentId, productId:sub.productId}"
              :danger="true"
              :loading="loadingData"
            >Remover</lms-button>
          </span>

          <!-- <span class="lesson-option">
                <a href="/aluno/turma/19/aula/64/" style="font-size: 14px;">Detalhes</a>
          </span>-->
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import NewSubscription from "./NewSubscription";

export default {
  props: {
    subscriptions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      deleteLoading: false,
      deleteSubscription: null,
      loadingData: false,
      test: false,
      savingQuiz: false,
      showNew: false,
      userId: this.$store.getters.userEdit.id
    };
  },
  components: {
    NewSubscription
  },
  methods: {
    removeSubscription() {
      this.deleteLoading = true;
      const path = this.$global.endpoint + "/subscription/remove";
      axios
        .post(path, {
          productId: this.deleteSubscription.productId,
          paymentId: this.deleteSubscription.paymentId,
          userId: this.userId
        })
        .then(res => {
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Inscrição removida"
          });
          this.deleteLoading = false;
          this.deleteSubscription = null;
          this.$emit("update");
        })
        .catch(error => {
          this.deleteLoading = false;
          this.deleteSubscription = null;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: "Erro ao remover a inscrição"
          });
        });
    },
    newSubscription() {
      this.showNew = true;
    },
    getSubscriptions() {
      this.$emit("update");
    }
  },
  created() {}
};
</script>
